<template>
  <div
    class="tir-pm-text-editor-file-line-tool"
    :class="{
      'tir-pm-text-editor-file-line-tool--floating': props.isFloatingLine,
    }"
    @mousedown="onMousedown"
  >
    <div class="tir-pm-text-editor-file-line-tool__wrapper-button">
      <div class="tir-pm-text-editor-file-line-tool__button">
        <TirPmButton
          :variant="TirPmButtonVariantEnum.LinkState"
          :size="TirPmButtonSizeEnum.Small"
          title="Жирность Ctrl+B"
          :isActive="isBoldActiveComputed"
          @click="execButtonCommnad('bold')"
          @touchend="execButtonCommnad('bold')"
        >
          <template #leftSlot><BoldIcon></BoldIcon></template>
        </TirPmButton>
      </div>
      <div class="tir-pm-text-editor-file-line-tool__button">
        <TirPmButton
          :variant="TirPmButtonVariantEnum.LinkState"
          :size="TirPmButtonSizeEnum.Small"
          title="Курсив Ctrl+I"
          :isActive="isItalicActiveComputed"
          @click="execButtonCommnad('italic')"
          @touchend="execButtonCommnad('italic')"
        >
          <template #leftSlot><ItalicIcon></ItalicIcon></template>
        </TirPmButton>
      </div>
    </div>
    <div class="tir-pm-text-editor-file-line-tool__divider"></div>
    <div class="tir-pm-text-editor-file-line-tool__wrapper-button">
      <div class="tir-pm-text-editor-file-line-tool__button">
        <TirPmButton
          :variant="TirPmButtonVariantEnum.LinkState"
          :size="TirPmButtonSizeEnum.Small"
          title="Подчеркнутый Ctrl+U"
          :isActive="isUnderlineActiveComputed"
          @click="execButtonCommnad('underline')"
          @touchend="execButtonCommnad('underline')"
        >
          <template #leftSlot><UnderlineIcon></UnderlineIcon></template>
        </TirPmButton>
      </div>
      <div class="tir-pm-text-editor-file-line-tool__button">
        <TirPmButton
          :variant="TirPmButtonVariantEnum.LinkState"
          :size="TirPmButtonSizeEnum.Small"
          title="Перечеркнутый Ctrl+Shift+X"
          :isActive="isStrikeActiveComputed"
          @click="execButtonCommnad('strikeThrough')"
          @touchend="execButtonCommnad('strikeThrough')"
        >
          <template #leftSlot><StrikethroughIcon></StrikethroughIcon></template>
        </TirPmButton>
      </div>
      <div class="tir-pm-text-editor-file-line-tool__button">
        <TirPmPopover
          class="tir-pm-text-editor-file-line-tool-popover"
          width="11.5rem"
          :isNoTeleport="true"
        >
          <template #default="{ isOpened }">
            <TirPmButton
              :variant="TirPmButtonVariantEnum.LinkState"
              :size="TirPmButtonSizeEnum.Small"
              :isActive="isOpened || isSelectedActiveColorComputedFromList"
              title="Цвет текста"
              ><template #leftSlot
                ><ColorationIcon></ColorationIcon
              ></template> </TirPmButton
          ></template>

          <template #content>
            <div
              class="tir-pm-text-editor-file-line-tool-popover__content-color"
            >
              <TirPmButton
                :variant="TirPmButtonVariantEnum.LinkState"
                :size="TirPmButtonSizeEnum.Small"
                @click="toSendColor(item.Color)"
                :isActive="item.Color == isSelectedActiveColorComputed"
                v-for="item of colorList"
                :key="item.Id"
              >
                <template #leftSlot
                  ><DimondIcon :style="{ color: item.Color }"></DimondIcon
                ></template>
              </TirPmButton>
            </div>
          </template>
        </TirPmPopover>
      </div>
      <div class="tir-pm-text-editor-file-line-tool__button">
        <TirPmPopover
          class="tir-pm-text-editor-file-line-tool-popover"
          width="25rem"
          :isNoTeleport="true"
          :disable-content-blur="true"
          @close="onClosePopoverLink"
          ref="$linkPopover"
          ><TirPmButton
            :variant="TirPmButtonVariantEnum.LinkState"
            :size="TirPmButtonSizeEnum.Small"
            title="Присвоить ссылку Ctrl+K"
          >
            <template #leftSlot><LinkIcon></LinkIcon></template>
          </TirPmButton>

          <template #content>
            <div
              class="tir-pm-text-editor-file-line-tool-popover__content-link"
              @click.stop
            >
              <TirPmInput
                label="Вставьте ссылку"
                v-model="linkToSave"
                auto-focus
                @focus="onFocusInput"
                :is-with-hint="!!formValidator.errors.value?.Link"
                :is-show-hint="!!formValidator.errors.value?.Link"
                :is-with-error="!!formValidator.errors.value?.Link"
                @enter="toSendLink"
              >
                <template #hintMessage>
                  {{ formValidator.errors.value?.Link }}
                </template>
              </TirPmInput>
              <TirPmButton
                :variant="TirPmButtonVariantEnum.PrimaryState"
                :size="TirPmButtonSizeEnum.Small"
                :is-disabled="isDisabledButtonSaveLink"
                @click="toSendLink"
              >
                Сохранить
              </TirPmButton>
            </div>
          </template>
        </TirPmPopover>
      </div>
      <div class="tir-pm-text-editor-file-line-tool__divider"></div>
      <div class="tir-pm-text-editor-file-line-tool__button">
        <TirPmButton
          :variant="TirPmButtonVariantEnum.LinkState"
          :size="TirPmButtonSizeEnum.Small"
          title="Прижать к левому краю Ctrl+L"
          @click="execButtonCommnad('justifyLeft')"
          @touchend="execButtonCommnad('justifyLeft')"
        >
          <template #leftSlot
            ><Bars3BottomLeftIcon></Bars3BottomLeftIcon
          ></template>
        </TirPmButton>
      </div>
      <div class="tir-pm-text-editor-file-line-tool__button">
        <TirPmButton
          :variant="TirPmButtonVariantEnum.LinkState"
          :size="TirPmButtonSizeEnum.Small"
          title="По всей ширине Ctrl+J"
          @click="execButtonCommnad('justifyCenter')"
          @touchend="execButtonCommnad('justifyCenter')"
        >
          <template #leftSlot><Bars3Icon></Bars3Icon></template>
        </TirPmButton>
      </div>
      <div class="tir-pm-text-editor-file-line-tool__button">
        <TirPmButton
          :variant="TirPmButtonVariantEnum.LinkState"
          :size="TirPmButtonSizeEnum.Small"
          title="Прижать к правому краю Ctrl+R"
          @click="execButtonCommnad('justifyRight')"
          @touchend="execButtonCommnad('justifyRight')"
        >
          <template #leftSlot
            ><Bars3BottomRightIcon></Bars3BottomRightIcon
          ></template>
        </TirPmButton>
      </div>
      <div class="tir-pm-text-editor-file-line-tool__divider"></div>
      <div class="tir-pm-text-editor-file-line-tool__button">
        <TirPmButton
          :variant="TirPmButtonVariantEnum.LinkState"
          :size="TirPmButtonSizeEnum.Small"
          title="Список"
          @click="execButtonCommnad('insertUnorderedList')"
          @touchend="execButtonCommnad('insertUnorderedList')"
        >
          <template #leftSlot><ListBulletIcon></ListBulletIcon></template>
        </TirPmButton>
      </div>
      <div class="tir-pm-text-editor-file-line-tool__button">
        <TirPmButton
          :variant="TirPmButtonVariantEnum.LinkState"
          :size="TirPmButtonSizeEnum.Small"
          title="Нумерованный список"
          @click="execButtonCommnad('insertOrderedList')"
          @touchend="execButtonCommnad('insertOrderedList')"
        >
          <template #leftSlot><NumerationIcon></NumerationIcon></template>
        </TirPmButton>
      </div>
      <div class="tir-pm-text-editor-file-line-tool__divider"></div>
      <div class="tir-pm-text-editor-file-line-tool__button">
        <TirPmButton
          :variant="TirPmButtonVariantEnum.LinkState"
          :size="TirPmButtonSizeEnum.Small"
          title="Отступ справа"
          @click="execButtonCommnad('indent')"
          @touchend="execButtonCommnad('indent')"
        >
          <template #leftSlot><AdjustRightIcon></AdjustRightIcon></template>
        </TirPmButton>
      </div>
      <div class="tir-pm-text-editor-file-line-tool__button">
        <TirPmButton
          :variant="TirPmButtonVariantEnum.LinkState"
          :size="TirPmButtonSizeEnum.Small"
          title="Отступ слева"
          @click="execButtonCommnad('outdent')"
          @touchend="execButtonCommnad('outdent')"
        >
          <template #leftSlot><AdjustLeftIcon></AdjustLeftIcon></template>
        </TirPmButton>
      </div>
      <div class="tir-pm-text-editor-file-line-tool__divider"></div>
      <div class="tir-pm-text-editor-file-line-tool__button">
        <TirPmButton
          :variant="TirPmButtonVariantEnum.LinkState"
          :size="TirPmButtonSizeEnum.Small"
          title="Удалить все форматирование"
          @click="execButtonCommnad('removeFormat')"
          @touchend="execButtonCommnad('removeFormat')"
        >
          <template #leftSlot><XCircleIcon></XCircleIcon></template>
        </TirPmButton>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {
  TirPmButton,
  TirPmButtonVariantEnum,
  TirPmButtonSizeEnum,
} from "tir-pm-button";
import BoldIcon from "./icons/BoldIcon.vue";
import ItalicIcon from "./icons/ItalicIcon.vue";
import {
  LinkIcon,
  Bars3BottomLeftIcon,
  Bars3Icon,
  Bars3BottomRightIcon,
  ListBulletIcon,
  DimondIcon,
} from "tir-style-system/icons/solid";
import { XCircleIcon } from "tir-style-system/icons/outline";
import UnderlineIcon from "./icons/UnderlineIcon.vue";
import StrikethroughIcon from "./icons/StrikethroughIcon.vue";
import ColorationIcon from "./icons/ColorationIcon.vue";
import NumerationIcon from "./icons/NumerationIcon.vue";
import AdjustRightIcon from "./icons/AdjustRightIcon.vue";
import AdjustLeftIcon from "./icons/AdjustLeftIcon.vue";

import { TirPmPopover } from "tir-pm-popover";
import { TirPmInput } from "tir-pm-input";
import { computed, ref } from "vue";

import { watch } from "vue";
import {
  FormValidators,
  useFormValidator,
  ValidatorModel,
} from "tir-pm-form-validation";

/**Параметры компонента */
const props = defineProps({
  /**Виден ли компонент */
  visible: { type: Boolean, default: false },
  /**Виден ли уголок */
  cornerIsVisible: { type: Boolean, default: true },
  /**Активный цвет текста */
  activeTextColor: { type: String, default: "rgb(82, 82, 102)" },
  /**Активный цвет фона */
  activeBGColor: { type: String, default: "" },
  /**Активны ли скобки */
  isBracketsActive: { type: Boolean, default: false },
  /**Активнен ли жирный текст */
  isBoldActive: { type: Boolean, default: false },
  /**Активен ли курсив */
  isItalicActive: { type: Boolean, default: false },
  /**Активно ли подчеркивание */
  isUnderlineActive: { type: Boolean, default: false },
  /**Активно ли перечеркивание */
  isStrikeActive: { type: Boolean, default: false },
  /**Отображать ли кнопку для установки скобок [ ] */
  isSelectedActiveColor: { type: String, default: "" },
  previousLinkContent: { type: String, default: "" },
  /** Плавающий тулбар */
  isFloatingLine: { type: Boolean, default: false },
  isJustifyAlignActive: { type: Boolean, default: false },
  isLeftAlignActive: {
    type: Boolean,
    default: false,
  },
  isRightAlignActive: { type: Boolean, default: false },
});

const colorList = ref([
  {
    Id: "b74b4b21-16b0-4a8b-9027-8ebe058fe5a6",
    Color: "#0AA4D4",
  },
  {
    Id: "28646210-65ba-4079-a21d-5d3585cecb0a",
    Color: "#4480E7",
  },
  {
    Id: "11c66edc-41fc-4b89-a5b2-07d1b1225f9e",
    Color: "#2233CE",
  },
  {
    Id: "b6876738-723b-4725-8e73-7209a27dba31",
    Color: "#121AE8",
  },
  {
    Id: "ca8f0336-2083-40e1-b4b8-3e6ca43b64e9",
    Color: "#9D12DE",
  },
  {
    Id: "df2bfd97-8700-48ce-974e-3997c0a28088",
    Color: "#8330EC",
  },
  {
    Id: "ac8bc0fa-a1c0-49d0-a1fc-6d9a64eba84b",
    Color: "#5202B8",
  },
  {
    Id: "73567c3f-938b-4840-b6be-1e224efa7d10",
    Color: "#4A00C3",
  },
  {
    Id: "4b532a10-c8bd-4be9-9c1c-91014188ef1f",
    Color: "#E72381",
  },
  {
    Id: "d087ccf5-0575-45f8-96e2-f8f55165f665",
    Color: "#CE0000",
  },
  {
    Id: "647060f5-db2f-4894-af86-0b7cd0e78835",
    Color: "#B20036",
  },
  {
    Id: "d9383fc9-3534-42af-808f-4e9e44f68759",
    Color: "#AE0054",
  },
  {
    Id: "6d728ec8-769a-4934-b2c0-1385a1a49b00",
    Color: "#EA8313",
  },
  {
    Id: "4b67c9db-80b1-4b38-9239-daa919a6c9ef",
    Color: "#DD5D00",
  },
  {
    Id: "40ca79c4-162a-4b65-9935-bf762ef39cc5",
    Color: "#B24000",
  },
  {
    Id: "3c86ad35-a7ca-4172-a536-e21e6d9b22f5",
    Color: "#D03E00",
  },
  {
    Id: "f8b7b510-115e-4218-8176-7291eee0dfbb",
    Color: "#5ACC00",
  },
  {
    Id: "a06bf20d-6eed-4bf4-a4b1-ef9a2c8acced",
    Color: "#00B955",
  },
  {
    Id: "00000000-0000-0000-0000-000000000000",
    Color: "#039000",
  },
  {
    Id: "1210f5ce-0e8f-42ad-b3f3-3db215b185f0",
    Color: "#5F8000",
  },
]);

const isBoldActiveComputed = computed(() => {
  return props.isBoldActive;
});

const isUnderlineActiveComputed = computed(() => {
  return props.isUnderlineActive;
});

const isStrikeActiveComputed = computed(() => {
  return props.isStrikeActive;
});

const isItalicActiveComputed = computed(() => {
  return props.isItalicActive;
});

const isSelectedActiveColorComputed = computed(() => {
  return props.isSelectedActiveColor;
});

const previousLinkContentComputed = computed(() => {
  return props.previousLinkContent;
});

const isSelectedActiveColorComputedFromList = computed(() => {
  return !!colorList.value.find((x) => props.isSelectedActiveColor == x.Color);
});

const onFocusInput = (e: any) => {
  emit("focusInput", e);
};

/**События компонента */
const emit = defineEmits<{
  (eventName: "command", value: any): void;
  (eventName: "focus"): void;
  (eventName: "focusInput", value: Event): void;
}>();

const linkToSave = ref<string>("");

watch(previousLinkContentComputed, (newvalue) => {
  linkToSave.value = newvalue;
});

const linkValidator = new ValidatorModel<string | undefined>({
  GetErrorMessage: () => "Ссылка не валидная",
  ValidationFn: (value) => {
    if (!value) return false;
    // Обновленное регулярное выражение
    const regex = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/;
    return regex.test(value);
  },
});

const $linkPopover = ref(null);

const formValidator = useFormValidator(
  computed(() => ({
    Link: linkToSave.value,
  })),
  {
    Link: [linkValidator],
  }
);

const isDisabledButtonSaveLink = computed(
  () => !linkToSave.value?.trim() || formValidator.isDisabledSubmit.value
);

/**Форматирование ссылки */
const formatLink = (url: string): string => {
  // Удаляем лишние пробелы в начале и конце
  const trimmedUrl = url.trim();

  // Если начинается с протоколов http:// или https://, ничего не делаем
  if (trimmedUrl.startsWith("http://") || trimmedUrl.startsWith("https://")) {
    return trimmedUrl;
  }

  // Если начинается с www., добавляем https:// перед www
  if (trimmedUrl.startsWith("www.")) {
    return "https://" + trimmedUrl;
  }

  // В остальных случаях добавляем https:// перед ссылкой
  return "https://" + trimmedUrl;
};

const toSendLink = () => {
  if (!formValidator.StartValidate()) return;
  if (linkToSave.value.length) {
    execButtonCommnad("createLink", formatLink(linkToSave.value));
  }
  $linkPopover.value.close();
};

const toSendColor = (color: string) => {
  if (color && isSelectedActiveColorComputed.value !== color) {
    execButtonCommnad("backColor", color);
  } else {
    execButtonCommnad("backColor", "transparent");
  }
};

const onClosePopoverLink = () => {
  linkToSave.value = "";
  formValidator.StopValidate();
};

/**Выполнение команды кнопки */
const execButtonCommnad = (command: any, additionalData?: any) => {
  console.log(command, additionalData);
  emit("command", {
    command: command,
    additionalData: encodeURI(additionalData),
  });
};
/**Зажатие ЛКМ на компоненте */
const onMousedown = (e: MouseEvent) => {
  emit("focus");
};
const openLincPopover = () => {
  $linkPopover.value.open();
};
defineExpose({
  execButtonCommnad,
  openLincPopover,
});
</script>
